import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { valsubstr32addbr } from '@/utils';
import NoData from '@/components/NoData/NoData';
import manage from '@/constants/manage';
export default {
  name: 'userAdd',
  inject: ['dict_info'],
  component: {
    NoData: NoData
  },
  data: function data() {
    var validatePass2 = function validatePass2(rule, value, callback) {
      var reg = new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$');
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的邮箱号'));
      }
    };
    return {
      formInline: {
        userId: '',
        userName: '',
        mngLevel: '',
        jobCodeList: [],
        mail: '',
        telephone: '',
        orgId: '',
        busLinCode: '',
        userStatus: 'VALID',
        manageList: [],
        jobName: []
      },
      rules: {
        userName: [{
          required: true,
          message: '请输入用户名称',
          trigger: 'blur'
        }],
        userId: [{
          validator: function validator(rule, value, callback) {
            if (/[\u4E00-\u9FA5]/g.test(value)) {
              callback(new Error('请勿输入中文'));
            } else {
              // 校验通过
              callback();
            }
          },
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入用户编号',
          trigger: 'blur'
        }],
        mail: [{
          required: true,
          validator: validatePass2,
          trigger: 'blur'
        }],
        mngLevel: [{
          required: true,
          message: '请选择职级',
          trigger: 'change'
        }],
        jobCodeList: [{
          required: true,
          message: '请选择职位',
          trigger: 'change'
        }],
        orgId: [{
          required: true,
          message: '请选择所属部门',
          trigger: 'blur'
        }]
      },
      searchList: {
        systemId: '',
        roleName: ''
      },
      userConfig: {
        userName: '',
        userId: '',
        corner: 'A',
        systemId: '',
        roleId: '',
        orgId: '',
        roleName: '',
        roleInfo: null,
        manageOrgList: [],
        bizLineList: [],
        canSetManageLine: false,
        canSetbusinessLine: false
      },
      userConfigRules: {
        systemId: [{
          required: true,
          message: '请输入角色名称',
          trigger: 'change'
        }],
        roleInfo: [{
          required: true,
          message: '请选择角色名称',
          trigger: 'change'
        }],
        roleName: [{
          required: true,
          message: '请选择角色名称',
          trigger: 'change'
        }],
        manageOrgList: [{
          required: true,
          message: '请添加管辖部门',
          trigger: 'change'
        }],
        bizLineList: [{
          required: true,
          message: '请添加管辖条线',
          trigger: 'change'
        }],
        corner: [{
          required: true,
          message: '请选择AB角',
          trigger: 'change'
        }]
      },
      tableheight: 380,
      showLoading: false,
      tableData: [],
      ifShowDelDialog: false,
      showRoleConfig: false,
      systemList: [],
      dictInfo: {},
      mngList: [],
      buslinList: [],
      dictList: JSON.parse(sessionStorage.getItem('dist_info')),
      mngInfo: {},
      manageLoading: false,
      manageList: [],
      editOrgPath: [],
      showUserInfoList1: [{
        key: 'userId',
        value: '用户编码'
      }, {
        key: 'userName',
        value: '用户名称'
      }, {
        key: 'mngLevel',
        value: '职级'
      }, {
        key: 'jobCodeList',
        value: '职位'
      }, {
        key: 'mail',
        value: '邮箱地址'
      }],
      showUserInfoList2: [{
        key: 'telephone',
        value: '联系方式'
      }, {
        key: 'pathName',
        value: '所属机构'
      }, {
        key: 'busLinCode',
        value: '所属条线'
      }, {
        key: 'userStatus',
        value: '用户状态'
      }],
      state: [{
        key: 'VALID',
        value: '有效'
      }, {
        key: 'INVALID',
        value: '失效'
      }],
      roleList: [],
      // 角色列表
      saveSuccess: false,
      isAdd: false,
      isEdit: false,
      isCheck: false,
      editUser: false,
      isAddRole: false,
      editBtn: false,
      orgErrMSg: null,
      topId: manage.HEAD_ORG_ID
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 520;
      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 520;
      };
    });
  },
  created: function created() {
    this.init();
    if (this.$route.query.isAdd === '1') {
      this.isAdd = true;
      this.editUser = true;
    } else if (this.$route.query.isEdit === '1') {
      this.isEdit = true;
      this.editBtn = true;
      document.title = '编辑用户';
      this.editUser = true;
      this.getUserInfoForUserId(this.$route.query.userId);
    } else if (this.$route.query.isAddCheck === '1') {
      this.isEdit = true;
      this.editUser = false;
      this.getUserInfoForUserId(this.$route.query.userId);
    } else {
      this.isCheck = true;
      this.editUser = false;
      this.getUserInfoForUserId(this.$route.query.userId);
    }
  },
  methods: {
    subCancel: function subCancel() {
      this.showRoleConfig = false;
      this.userConfig.bizLineList = [];
      this.userConfig.manageOrgList = [];
      this.userConfig.canSetbusinessLine = false;
      this.userConfig.canSetManageLine = false;
    },
    init: function init() {
      var _this = this;
      this.dictInfo = this.dictList.BUSINESS_LINE || null;
      this.mngInfo = this.dictList.MANAGER_LEVEL || null;
      var obj = this.dictInfo;
      if (this.dictInfo !== null) {
        // eslint-disable-next-line guard-for-in
        for (var i in obj) {
          this.buslinList.push({
            key: i,
            value: obj[i]
          });
        }
      }
      obj = this.mngInfo;
      if (this.mngInfo !== null) {
        // eslint-disable-next-line guard-for-in
        for (var _i in obj) {
          this.mngList.push({
            key: _i,
            value: obj[_i]
          });
        }
      }
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          res.result.records.forEach(function (item) {
            var selectvalue = {
              value: item.systemId,
              label: item.systemName
            };
            // this.systemList.push(selectvalue);
            if (item.isPublicResource != 1) {
              _this.systemList.push(selectvalue);
            }
          });
        }
      });
    },
    editUserInfo: function editUserInfo() {
      this.editUser = true;
      this.editBtn = true;
    },
    // 编辑角色信息
    resetSearch: function resetSearch() {
      this.searchList = Object.assign({}, {
        systemId: '',
        roleName: ''
      });
      this.search();
    },
    edit: function edit(data) {
      var _this2 = this;
      this.isAddRole = false;
      this.showRoleConfig = true;
      setTimeout(function () {
        _this2.$refs.userConfig.resetFields();
        _this2.userConfig = Object.assign(_this2.userConfig, data);
        _this2.userConfig.roleInfo = data.roleName;
        _this2.userConfig.canSetbusinessLine = data.canSetBizLine === 1;
        _this2.userConfig.canSetManageLine = data.canSetManageOrg === 1;
        _this2.userConfig.userName = _this2.formInline.userName;
        _this2.userConfig.userId = _this2.formInline.userId;
      }, 300);
    },
    getRoleId: function getRoleId(role) {
      this.userConfig.roleId = role.roleId;
      this.userConfig.bizLineList = role.manageLineId;
      this.userConfig.manageOrgList = role.manageOrgId;
      this.userConfig.canSetbusinessLine = this.userConfig.roleInfo.canSetBizLine;
      this.userConfig.canSetManageLine = this.userConfig.roleInfo.canSetManageOrg;
    },
    // 根据系统查询角色
    changeSystemId: function changeSystemId(systemId) {
      var _this3 = this;
      this.userConfig.roleInfo = null;
      return new Promise(function (resolve) {
        _this3.$API.getRequest({
          url: '/platform/roleInner/queryNotConfigRole',
          data: {
            systemId: systemId,
            userId: _this3.formInline.userId
          }
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this3.roleList = res.result;
            resolve();
          }
        });
      });
    },
    // 新增角色
    pushRole: function pushRole() {
      this.isAddRole = true;
      this.showRoleConfig = true;
      this.$refs.userConfig && this.$refs.userConfig.resetFields();
      this.userConfig.userName = this.formInline.userName;
      this.userConfig.userId = this.formInline.userId;
    },
    // 查询用户角色信息
    search: function search() {
      var _this4 = this;
      return new Promise(function (resolve) {
        _this4.$API.getRequest({
          url: '/platform/user/userRole',
          data: _objectSpread({
            userId: _this4.formInline.userId
          }, _this4.searchList)
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this4.tableData = res.result;
            _this4.$nextTick(function () {
              if (_this4.$refs.multipleTable && _this4.$refs.multipleTable.doLayout) {
                _this4.$refs.multipleTable.doLayout();
              }
            });
            resolve();
          }
        });
      });
    },
    getState: function getState(state) {
      if (state === 'VALID') {
        return '有效';
      } else {
        return '失效';
      }
    },
    getUserInfoForUserId: function getUserInfoForUserId(userId) {
      var _this5 = this;
      var userInfo = null;
      this.$API.getRequest({
        url: '/platform/user/userIdAndUserName',
        data: {
          pageSize: 10,
          pageNum: 1,
          userId: userId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          userInfo = res.result.records[0];
          if (!userInfo.mngLevel) {
            delete userInfo.mngLevel;
          }
          if (!userInfo.jobCodeList) {
            delete userInfo.jobCodeList;
          }
          _this5.formInline.jobCodeList = [];
          userInfo.jobList && userInfo.jobList.forEach(function (ele) {
            _this5.formInline.jobCodeList.push("".concat(ele.jobName, "/").concat(ele.jobCode));
            _this5.manageList.push({
              jobCode: "".concat(ele.jobName, "/").concat(ele.jobCode),
              jobName: "".concat(ele.jobName, "/").concat(ele.jobCode)
            });
          });
          _this5.formInline = Object.assign(_this5.formInline, userInfo);
          // let org = []
          // org.push(userInfo.orgId)
          _this5.formInline.orgId = userInfo.orgId;
          _this5.search().then(function () {});
        }
      });
    },
    getLevelInfo: function getLevelInfo(list) {
      var name = '';
      if (list) {
        list.forEach(function (ele) {
          name = "".concat(name + ele.jobName, "/").concat(ele.jobCode, "  ");
        });
      }
      return name;
    },
    searchForm: function searchForm() {
      var _this6 = this;
      this.$API.getRequest({
        url: '/platform/user/userIdAndUserName',
        data: {
          userId: this.formInline.userId,
          pageSize: 10,
          pageNum: 1
        }
      }).then(function (res) {
        _this6.showTable = false;
        if (res.code === '0000000000') {
          // this.showTable = false
          _this6.formInline = Object.assign(_this6.formInline, res.result.records[0]);
        }
      });
    },
    saveUserInfo: function saveUserInfo() {
      var _this7 = this;
      var data = _objectSpread({}, this.formInline);
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this7.editBtn) {
            _this7.$API.putRequest({
              url: '/platform/user',
              data: data
            }).then(function (res) {
              if (res.code === '0000000000') {
                // this.searchForm();
                _this7.$message({
                  message: '保存成功！',
                  type: 'success'
                });
                var userInfo = res.result[0];
                _this7.formInline.jobCodeList = [];
                userInfo.jobList && userInfo.jobList.forEach(function (ele) {
                  _this7.formInline.jobCodeList.push("".concat(ele.jobName, "/").concat(ele.jobCode));
                  _this7.manageList = [];
                  _this7.manageList.push({
                    jobCode: "".concat(ele.jobName, "/").concat(ele.jobCode),
                    jobName: "".concat(ele.jobName, "/").concat(ele.jobCode)
                  });
                });
                _this7.formInline = Object.assign(_this7.formInline, userInfo);
                // let org = []
                // org.push(userInfo.orgId)
                _this7.formInline.orgId = userInfo.orgId;
                _this7.editUser = false;
                _this7.search();
              }
            });
          } else {
            _this7.$API.postRequest({
              url: '/platform/user',
              data: data
            }).then(function (res) {
              if (res.code === '0000000000') {
                // this.searchForm();
                _this7.$message({
                  message: '保存成功！',
                  type: 'success'
                });
                var userInfo = res.result[0];
                _this7.formInline.jobCodeList = [];
                userInfo.jobList && userInfo.jobList.forEach(function (ele) {
                  _this7.formInline.jobCodeList.push("".concat(ele.jobName, "/").concat(ele.jobCode));
                  _this7.manageList.push({
                    jobCode: "".concat(ele.jobName, "/").concat(ele.jobCode),
                    jobName: "".concat(ele.jobName, "/").concat(ele.jobCode)
                  });
                });
                _this7.formInline = Object.assign(_this7.formInline, userInfo);
                _this7.formInline.orgId = userInfo.orgId;
                _this7.saveSuccess = true;
                _this7.isEdit = !_this7.isCheck;
                _this7.editUser = false;
                _this7.$router.replace({
                  path: '/system/addUser',
                  query: {
                    userId: res.result[0].userId,
                    isAddCheck: '1'
                  }
                });
                _this7.search();
              }
            });
          }
        } else {
          _this7.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    submitUserForm: function submitUserForm() {
      var _this8 = this;
      this.$refs.userConfig.validate(function (valid) {
        if (valid) {
          var data = {};
          if (_this8.isAddRole) {
            data = Object.assign(_this8.userConfig, _this8.userConfig.roleInfo);
            data.orgId = _this8.formInline.orgId;
            _this8.$API.postRequest({
              url: '/platform/customizedUser',
              data: data
            }).then(function (res) {
              if (res.code === '0000000000') {
                _this8.$message({
                  message: '添加成功',
                  type: 'success'
                });
                _this8.search().then(function () {
                  // this.showRoleConfig = false
                  _this8.showRoleConfig = false;
                  _this8.userConfig.bizLineList = [];
                  _this8.userConfig.manageOrgList = [];
                  _this8.userConfig.canSetbusinessLine = false;
                  _this8.userConfig.canSetManageLine = false;
                });
              }
            });
          } else {
            data = _this8.userConfig;
            data.orgId = _this8.formInline.orgId;
            if (data.resourceType === 'AUTO_CALCULATE') {
              _this8.$API.putRequest({
                url: '/platform/autoUser ',
                data: data
              }).then(function (res) {
                if (res.code === '0000000000') {
                  _this8.$message({
                    message: '编辑成功',
                    type: 'success'
                  });
                  _this8.userConfig.bizLineList = [];
                  _this8.userConfig.manageOrgList = [];
                  _this8.userConfig.canSetbusinessLine = false;
                  _this8.userConfig.canSetManageLine = false;
                  _this8.search().then(function () {
                    _this8.showRoleConfig = false;
                  });
                }
              });
            } else {
              _this8.$API.putRequest({
                url: '/platform/customizedUser',
                data: data
              }).then(function (res) {
                if (res.code === '0000000000') {
                  _this8.$message({
                    message: '编辑成功',
                    type: 'success'
                  });
                  _this8.userConfig.bizLineList = [];
                  _this8.userConfig.manageOrgList = [];
                  _this8.userConfig.canSetbusinessLine = false;
                  _this8.userConfig.canSetManageLine = false;
                  _this8.search().then(function () {
                    _this8.showRoleConfig = false;
                  });
                }
              });
            }
          }
        } else {
          _this8.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    delUserRole: function delUserRole(row) {
      var _this9 = this;
      var userIdList = [];
      userIdList.push(row.userId);
      this.$API.delRequest({
        url: '/platform/customizedUser',
        data: {
          roleId: row.roleId,
          systemId: row.systemId,
          userIdList: userIdList
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this9.$message({
            message: '删除角色成功！',
            type: 'success'
          });
          _this9.search();
        }
      });
    },
    getManageLevel: function getManageLevel(query) {
      var _this10 = this;
      if (query !== '') {
        this.manageLoading = true;
        this.$API.getRequest({
          url: '/platform/job/jobName',
          data: {
            pageSize: 5,
            pageNum: 1,
            jobName: query
          }
        }).then(function (res) {
          _this10.manageLoading = false;
          if (res.code === '0000000000') {
            _this10.manageList = res.result.map(function (ele) {
              return {
                jobCode: "".concat(ele.jobName, "/").concat(ele.jobCode),
                jobName: "".concat(ele.jobName, "/").concat(ele.jobCode)
              };
            });
          }
        });
      } else {
        this.options = [];
      }
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};